module.exports = __webpack_public_path__ + "static/media/CT_2019_30440A.b939d8f3.png";